__turbopack_context__.v({
  "ingelogdeGebruikerContainer": "gebruiker-dropdown-module-scss-module__IWU9HW__ingelogdeGebruikerContainer",
  "menuBtn": "gebruiker-dropdown-module-scss-module__IWU9HW__menuBtn",
});
